import OverviewAnalytics from "@onesolution/pages/app/_layout/Analytics/Overview";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/_layout/analytics/overview")({
	component: RouteComponent,
});

function RouteComponent() {
	return <OverviewAnalytics />;
}
